import { Field as Fieldmik, withFormik } from "formik";
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Button, Divider, Dropdown, Form as FormUi, Header, Radio } from 'semantic-ui-react';
import * as yup from "yup";
import {
    errorAlertDispatcher,
    infoAlertDispatcher,
    successAlertDispatcher,
    warningAlertDispatcher
} from "../../../redux/actions/alertAction";
import { AllRegex } from '../../../utils/validation';

import Axios from "axios";
import { Modal } from 'semantic-ui-react';

import axios from 'axios';
import { ERROR_MESSAGES } from "../../../config/const";
import { MyNormalInput,MyTextArea } from '../../formikInput/input';
import { LOCAL_STORAGE } from "../../utils/constants";
import SearchDropdown from "./searchDropdown";
import {billingPartyBranchConst, buttons} from './billingPartyConstants'
import CityDropdown from "../../dropdowns/cityDropdown";
import StateDropdown from "../../dropdowns/stateDropdown";
import cogoToast from "cogo-toast";

const BillingPartyBranch = ({ isSubmitting, handleSubmit,
    values, vendorId, setFieldValue,
    touched, errors, t, branchModal,
    CloseModal, editUserMode, ...props }) => {

    const [exemptedReasons, setExemptedReasons] = useState([])
    useEffect(() => {
        getExemptedReasons()
    }, [])

    const getExemptedReasons = () => {
        const congData = JSON.stringify({
            customerNumber: LOCAL_STORAGE.COOKIE_CUSTOMER_NO,
            userId: LOCAL_STORAGE.COOKIE_USER_ID,
            customer_no: +LOCAL_STORAGE.COOKIE_CUSTOMER_NO,
            customerNo: +LOCAL_STORAGE.COOKIE_CUSTOMER_NO,
            user_id: +LOCAL_STORAGE.COOKIE_USER_ID,
            ...props.payload
        });
        axios.post(`${process.env.REACT_APP_BASE_URL}/masters/gstExemptedReason`, congData, {
            headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.COOKIE_USER_TOKEN}`, "Access-Control-Allow-Origin": "*" }
        })
            .then((res) => {
                let result = res.data.resultSet.map((item, index) => {
                    return {
                        raw: { ...item },
                        text: item.GSTExemptedReasonName,
                        key: item.GSTExemptedReasonId,
                        value: item.GSTExemptedReasonId,
                    };
                });
                setExemptedReasons(result)
            })
            .catch((err) => {
                console.log("err", err.data);
            });
    };

    return (
        <Modal
            onClose={CloseModal}
            open={branchModal}
            size="large"
        >
            <Modal.Header style={{ fontSize: "14px" }}>{props.editData ? 'Edit Branch Detail' : 'Add Branch Detail'}</Modal.Header>
            <Modal.Content scrolling>
                <div className="ui form small">
                    <FormUi.Group>
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.branch_name?.title||"Branch Name"} <b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchName" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.branch_name?.placeholder} />
                            {touched.billingPartyBranchName && errors.billingPartyBranchName ? <small className="text-danger">{errors.billingPartyBranchName}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.state?.title||"State"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchStateId" component={StateDropdown} placeholder={values?.state ||billingPartyBranchConst?.fields?.state?.placeholder} className={values?.cityName ? "p-placeholder" : ""} />
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.city?.title||"City"} </label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchCityId" component={CityDropdown} placeholder={values?.cityName || billingPartyBranchConst?.fields?.city?.placeholder} className={values?.cityName ? "p-placeholder" : ""}/>
                            {touched.billingPartyBranchCityId && errors.billingPartyBranchCityId ? <small className="text-danger">{errors.cityNamebillingPartyBranchCityId}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.pincode?.title||"Pincode"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchPincode" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.pincode?.placeholder} />
                            {touched.billingPartyBranchPincode && errors.billingPartyBranchPincode ? <small className="text-danger">{errors.billingPartyBranchPincode}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    
                    <FormUi.Group>
                    <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.pan_number?.title||"Pan Number"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchPan" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.pan_number?.placeholder} />
                            {touched.billingPartyBranchPan && errors.billingPartyBranchPan ? <small className="text-danger">{errors.billingPartyBranchPan}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />

                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.contact_person?.title||"Contact Person Name"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="contactPersonName" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.contact_person?.placeholder} />
                            {touched.contactPersonName && errors.contactPersonName ? <small className="text-danger">{errors.contactPersonName}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>

                    <FormUi.Group>
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.mobile?.title||"Mobile No"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="mobileNo" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.mobile?.placeholder} />
                            {touched.mobileNo && errors.mobileNo ? <small className="text-danger">{errors.mobileNo}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />

                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.landline?.title||"LandLine No"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="landLineNo" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.landline?.placeholder} />
                            {touched.landLineNo && errors.landLineNo ? <small className="text-danger">{errors.landLineNo}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.address?.title||"Address"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchAddress" type="text" component={MyTextArea} placeholder={billingPartyBranchConst?.fields?.address?.placeholder} />
                            {touched.billingPartyBranchAddress && errors.billingPartyBranchAddress ? <small className="text-danger">{errors.billingPartyBranchAddress}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>

                    <Divider horizontal>
                        <Header as='h4'>
                            {billingPartyBranchConst?.gst_title||"GST Details"}
                        </Header>
                    </Divider>

                    <FormUi.Group>
                        <FormUi.Field width="2">
                            <label className="labelName mt-2">{billingPartyBranchConst?.fields?.is_gst_applicable.title||"Is GST Applicable?"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="2">
                            <Radio label="No" className='mt-2' name='isGstApplicable' value='No'
                                checked={values.isGstApplicable === false} onChange={() => { 
                                    setFieldValue("isGstApplicable", !values.isGstApplicable) 
                                    setFieldValue("billingPartyBranchGst", '') 
                                    setFieldValue("isGSTExempted", false) 
                                    setFieldValue("gstExemptedReasonId", '') 
                                    }} />
                        </FormUi.Field>
                        <FormUi.Field width="2">
                            <Radio label="Yes" className='mt-2' name='isGstApplicable' value='Yes'
                                checked={values.isGstApplicable === true} onChange={() => { setFieldValue("isGstApplicable", !values.isGstApplicable) }} />
                        </FormUi.Field>
                        <FormUi.Field width="2" />

                        {
                            values.isGstApplicable &&
                            <>
                                <FormUi.Field width="2">
                                    <label className="labelName mt-2">{billingPartyBranchConst?.fields?.gst_no?.title||"GST Number"} <b className="w3-text-red"> *</b></label>
                                </FormUi.Field>
                                <FormUi.Field width="4">
                                    <Fieldmik name="billingPartyBranchGst" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.gst_no?.placeholder} />
                                    {touched.billingPartyBranchGst && errors.billingPartyBranchGst ? <small className="text-danger">{errors.billingPartyBranchGst}</small> : ''}
                                </FormUi.Field>
                            </>
                        }
                    </FormUi.Group>
                    {values.isGstApplicable &&
                        <>
                            <FormUi.Group>
                                <FormUi.Field width="2">
                                    <label className="labelName mt-2">{billingPartyBranchConst?.fields?.is_gst_exempted.title||"Is GST Exempted?"}</label>
                                </FormUi.Field>
                                <FormUi.Field width="2">
                                    <Radio label="No" className='mt-2' name='isGSTExempted' value='No'
                                        checked={values.isGSTExempted === false} onChange={() => { 
                                            setFieldValue("isGSTExempted", !values.isGSTExempted)
                                            setFieldValue("gstExemptedReasonId", '')
                                             }} />
                                </FormUi.Field>
                                <FormUi.Field width="2">
                                    <Radio label="Yes" className='mt-2' name='isGSTExempted' value='Yes'
                                        checked={values.isGSTExempted === true} onChange={() => { setFieldValue("isGSTExempted", !values.isGSTExempted) }} />
                                </FormUi.Field>
                                <FormUi.Field width="2" />
                                {
                                    values.isGSTExempted &&
                                    <>
                                        <FormUi.Field width="2">
                                            <label className="labelName mt-2">{billingPartyBranchConst?.fields?.exempted_reason?.title||"GST Exempted Reason"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field className="labelName mt-2" width="4">
                                            <Dropdown
                                                selection
                                                name="gstExemptedReasonId"
                                                style={{ width: '100%' }}
                                                options={exemptedReasons}
                                                onChange={(name, data) => {
                                                    setFieldValue("gstExemptedReasonId", data.value);
                                                }}
                                                value={values.gstExemptedReasonId}
                                                placeholder = {billingPartyBranchConst?.fields?.exempted_reason?.placeholder}
                                            />
                                        </FormUi.Field>
                                    </>
                                }
                            </FormUi.Group>
                        </>
                    }
                    <Divider horizontal>
                        <Header as='h4'>
                            {billingPartyBranchConst?.bank_title||"Bank Details"}
                        </Header>
                    </Divider>
                    <FormUi.Group>
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.bank_name?.title||"Bank Name"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchBankName" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.bank_name?.placeholder} />
                            {touched.billingPartyBranchBankName && errors.billingPartyBranchBankName ? <small className="text-danger">{errors.billingPartyBranchBankName}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.account_holder?.title||"Account Holder"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchBankAccountHolder" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.account_holder?.placeholder} />
                            {touched.billingPartyBranchBankAccountHolder && errors.billingPartyBranchBankAccountHolder ? <small className="text-danger">{errors.billingPartyBranchBankAccountHolder}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group>
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.account_no?.title||"Account Number"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchAccountNumber" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.account_no?.placeholder} />
                            {touched.billingPartyBranchAccountNumber && errors.billingPartyBranchAccountNumber ? <small className="text-danger">{errors.billingPartyBranchAccountNumber}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="2" />
                        <FormUi.Field width="2">
                            <label className="labelName">{billingPartyBranchConst?.fields?.ifsc?.title||"IFSC Code"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="billingPartyBranchBankIFSC" type="text" component={MyNormalInput} placeholder={billingPartyBranchConst?.fields?.ifsc?.placeholder} />
                            {touched.billingPartyBranchBankIFSC && errors.billingPartyBranchBankIFSC ? <small className="text-danger">{errors.billingPartyBranchBankIFSC}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={CloseModal}>{buttons?.cancel||"cancel"}</Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">{buttons?.submit || "Submit"}</Button>
            </Modal.Actions>
        </Modal>
    )
}

const FormikUserEdit = withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        return {
            billingPartyBranchName: props?.editData?.billingPartyBranchName || '',
            billingPartyBranchPan : props?.editData?.billingPartyBranchPan || '',
            isGstApplicable: props?.editData?.isGstApplicable ? true : false,
            billingPartyBranchCode: props?.editData?.billingPartyBranchCode || null,
            cityName: props?.editData?.cityName || '',
            billingPartyBranchCityId: props?.editData?.billingPartyBranchCityId || '',
            billingPartyBranchPincode: props?.editData?.billingPartyBranchPincode || '',
            billingPartyBranchStateId: props?.editData?.billingPartyBranchStateId || '',
            state: props?.editData?.state || '',
            billingPartyBranchGst: props?.editData?.billingPartyBranchGst?.trim() || '',
            billingPartyBranchAddress: props?.editData?.billingPartyBranchAddress || '',
            billingPartyBranchBankName: props?.editData?.billingPartyBranchBankName || '',
            billingPartyBranchBankAccountHolder: props?.editData?.billingPartyBranchBankAccountHolder || '',
            billingPartyBranchAccountNumber: props?.editData?.billingPartyBranchAccountNumber || '',
            billingPartyBranchBankIFSC: props?.editData?.billingPartyBranchBankIFSC || '',
            billingPartyId: props?.billingPartyID || '',
            createdByName: props?.editData?.createdByName || null,
            updatedByName: props?.editData?.updatedByName || null,
            createdOn: props?.editData?.updatedByName || null,
            updatedOn: props?.editData?.updatedOn || null,
            contactPersonName: props?.editData?.contactPersonName || '',
            mobileNo: props?.editData?.mobileNo || '',
            landLineNo: props?.editData?.landLineNo || '',
            isGSTExempted: props?.editData?.isGSTExempted ? true : false,
            gstExemptedReasonId: props?.editData?.GSTExemptedReasonId || '',
        }
    },
    validationSchema: yup.object({
        billingPartyBranchName: yup.string().required(ERROR_MESSAGES.FIELD_IS_REQUIRED).max(50,ERROR_MESSAGES.INVALID_MAXIMUMSIZE(50)),
        billingPartyBranchCityId: yup.number().optional().nullable(),
        billingPartyBranchPincode: yup.string().optional().nullable().matches(AllRegex.Pincode, ERROR_MESSAGES.INVALID_PINCODE),
        billingPartyBranchStateId: yup.number().optional().nullable(),
        billingPartyBranchPan :  yup.string().optional().nullable().matches(AllRegex.PANIN, ERROR_MESSAGES.INVALID_PAN_NO),
        billingPartyBranchGst: yup.string().when('isGstApplicable', {
            is: (isGstApplicable) => {
                return isGstApplicable && isGstApplicable == true ? true : false
            },
            then: yup.string().required(ERROR_MESSAGES.FIELD_IS_REQUIRED).matches(AllRegex.GSTIN, ERROR_MESSAGES.INVALID_GST_NUMBER),
            otherwise: yup.string().optional().nullable().matches(AllRegex.GSTIN, ERROR_MESSAGES.INVALID_GST_NUMBER),
        }),
        billingPartyBranchBankName: yup.string().optional().matches(AllRegex.Name, ERROR_MESSAGES.INVALID_NAME).nullable().max(50,ERROR_MESSAGES.INVALID_MAXIMUMSIZE(50)),
        billingPartyBranchAccountNumber: yup.string().optional().matches(AllRegex.BankAccNumber, ERROR_MESSAGES.INVALID_BANK_ACCOUNT_NO).nullable(),
        billingPartyBranchBankIFSC: yup.string().optional().matches(AllRegex.BankIFSCcode, ERROR_MESSAGES.INVALID_IFSC_CODE).nullable().max(30,ERROR_MESSAGES.INVALID_MAXIMUMSIZE(50)),
        billingPartyBranchBankAccountHolder: yup.string().optional().matches(AllRegex.Name, ERROR_MESSAGES.INVALID_NAME).nullable(),
        mobileNo: yup.string().optional().matches(AllRegex.MobileNumber, ERROR_MESSAGES.INVALID_MOBILE_NO).nullable(),
        landLineNo: yup.string().optional().matches(AllRegex.landLineNo, ERROR_MESSAGES.INVALID_LAND_LINE).nullable(),
        billingPartyBranchAddress: yup.string().optional().matches(AllRegex.Address, ERROR_MESSAGES.INVALID_ADDRESS).nullable(),
        contactPersonName: yup.string().optional().matches(AllRegex.Name, ERROR_MESSAGES.INVALID_NAME).nullable().max(50,ERROR_MESSAGES.INVALID_MAXIMUMSIZE(50)),
    }),

    async handleSubmit(values, { props }) {
        if(!values.isGSTExempted) values.gstExemptedReasonId= '0'
        if(values.isGstApplicable===true){
            values.isGstApplicable = '1'
        }else{
            values.isGstApplicable = '0'
            values.billingPartyBranchGst=' '
            values.isGSTExempted=false
            values.gstExemptedReasonId= '0'
        }
        const apiData = JSON.stringify({
            customerNumber: LOCAL_STORAGE.customerNo,
            userId: LOCAL_STORAGE.userId,
            customer_no: +LOCAL_STORAGE.customerNo,
            customerNo: +LOCAL_STORAGE.customerNo,
            user_id: +LOCAL_STORAGE.userId,
            ...values,
        });

        if (props?.editData?.billingPartyBranchId) {
            await Axios.patch(`${process.env.REACT_APP_BASE_URL}/masters/billing_party_branch/${props.editData.billingPartyBranchId}`, apiData, {
                headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}`, "Access-Control-Allow-Origin": "*" }
            }).then((response) => {
                if(response?.data?.status===200){
                    cogoToast.success(response?.data?.message, { position: 'top-right' })
                    setTimeout(() => {
                        window.location.reload()
                      }, 1500);
                   }else{
                    cogoToast.error(response?.data?.message, { position: 'top-right' })
                   }
            })
                .catch((err) => {
                    // if (err.data.status === 204) {
                    //     let alert = {
                    //         type: "error",
                    //         messageHeader: "Error",
                    //         messageBody: `Unable to update. ${props.productName},${err.data.message} `,
                    //     };
                    //     props.errorAlertDispatcher(alert);
                    // }
                    console.log(err?.response?.data?.message);
                    window.location.reload()
                });
        } else {
            const apiURL = `${process.env.REACT_APP_BASE_URL}/masters/billing_party_branch/`
            await Axios.put(apiURL, apiData, {
                headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}`, "Access-Control-Allow-Origin": "*" }
            }).then((res) => {
                if(res?.data?.status===200){
                    cogoToast.success(res?.data?.message, { position: 'top-right' })
                    setTimeout(() => {
                        window.location.reload()
                      }, 1500);
                   }else{
                    cogoToast.error(res?.data?.message, { position: 'top-right' })
                   }
            })
                .catch((err) => {
                    // if (err.data.status === 204) {
                    //     let alert = {
                    //         type: "error",
                    //         messageHeader: "Error",
                    //         messageBody: `Unable to create ${props.productName},${err.data.message}`,
                    //     };
                    //     props.errorAlertDispatcher(alert);
                    // }
                    // props.CloseModal(true)
                    // window.location.reload()
                    // props.successAlertDispatcher(alert);
                    // props.onFormSubmit();
                    console.log(err?.response?.data?.message);
                    window.location.reload()
                });
        }
    }
})(BillingPartyBranch)

export default connect(null, {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
})(FormikUserEdit)
